export function toLowerCase(req, res) {
    const pathname = req.url.pathname;
    if (pathname === '/') {
        return;
    }
    const lowerCasePath = pathname.toLowerCase();
    if (pathname !== lowerCasePath) {
        return res.redirect(lowerCasePath, 301);
    }
}
